export const listLevelStudy = [
    "Tecnólogo(a).",
    "Universitario(a).",
    "Especialización.",
    "Maestría.",
    "Doctorado.",
];